import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";

const DEMO_AD_HLS = "https://test-streams.mux.dev/dai-discontinuity-deltatre/manifest.m3u8";

const SAMPLES = [
  ["Mux demo", "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8"],
  ["Big Buck Bunny", "https://test-streams.mux.dev/pts_shift/master.m3u8"],
  ["Apple bipbop", "https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_ts/master.m3u8"],
  ["Discontinuity", DEMO_AD_HLS],
];

/** HLS URL input + sample-stream quick picks. */
export default function HlsInputPanel({ url, setUrl, demoUrl, setDemoUrl }) {
  const { user } = useAuth();
  const canWrite = user && ["super_admin", "tenant_admin", "scheduler"].includes(user.role);
  return (
    <div className="space-y-3">
      <div>
        <Label className="text-[10px] uppercase tracking-widest text-muted-foreground">Preview HLS URL</Label>
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://…/master.m3u8"
          className="mt-1 bg-card border-border font-mono text-xs"
          data-testid="channel-hls-url-input"
        />
        <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mt-2">Sample streams</div>
        <div className="flex flex-wrap gap-1 mt-1">
          {SAMPLES.map(([lbl, u]) => (
            <button
              key={u}
              type="button"
              onClick={() => setUrl(u)}
              data-testid={`hls-sample-${lbl.toLowerCase().replace(/\s+/g,'-')}`}
              className="text-[10px] font-mono px-2 py-1 rounded-sm border border-border text-foreground/80 hover:border-primary/60"
            >
              {lbl}
            </button>
          ))}
        </div>
      </div>

      {setDemoUrl && (
        <div className="gradient-stroke rounded-xl p-3">
          <Label className="text-[10px] uppercase tracking-widest text-muted-foreground">Demo fallback HLS URL</Label>
          <Input
            value={demoUrl || ""}
            onChange={(e) => setDemoUrl(e.target.value)}
            placeholder="https://…/demo.m3u8 (used when today's schedule assets aren't on CDN yet)"
            className="mt-1 bg-card border-border font-mono text-xs"
            data-testid="channel-demo-hls-url-input"
            readOnly={!canWrite}
            disabled={!canWrite}
          />
          <div className="text-[10px] font-mono text-muted-foreground mt-1">
            {canWrite
              ? "Plays on the Dashboard tile when the current schedule slot isn't on Cloudflare Stream yet AND there's no active live broadcast — prevents a 204/blank tile."
              : "Read-only for this role. Ask a scheduler or admin to change it."}
          </div>
          {canWrite && (
            <div className="flex flex-wrap gap-1 mt-2">
              {SAMPLES.map(([lbl, u]) => (
                <button
                  key={u}
                  type="button"
                  onClick={() => setDemoUrl(u)}
                  data-testid={`demo-hls-sample-${lbl.toLowerCase().replace(/\s+/g,'-')}`}
                  className="text-[10px] font-mono px-2 py-1 rounded-sm border border-border text-foreground/80 hover:border-primary/60"
                >
                  {lbl}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
